import { useApolloClient, useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { GET_CONSULTA_COMBO, GET_PARAMETROS_BY_CONSULTA, adaptComboOption, adaptParametro } from "../../../data/graphQL/queries/ConsultasGenerales/getParametrosByConsulta";

export const useGetParametros = (idConsulta) => {
    const client = useApolloClient();

    const [parametros, setParametros] = useState([]);
    const [parametrosLoading, setParametrosLoading] = useState(false);
    const [parametrosError, setParametrosError] = useState(null);

    const [getParametrosQuery] = useLazyQuery(GET_PARAMETROS_BY_CONSULTA);

    useEffect(() => {
        if (!idConsulta) {
            setParametros([]);
            setParametrosError(null);
            return;
        }

        setParametrosLoading(true);

        getParametrosQuery({ variables: { idConsulta } })
            .then(async ({ data }) => {
                const parametrosData = data.consultaFiltros || [];

                const processedParametros = await Promise.all(
                    parametrosData.map(async (parametro) => {
                        if (parametro.esCombo) {
                            try {
                                const { data: comboData } = await client.query({
                                    query: GET_CONSULTA_COMBO,
                                    variables: { idConsultaFiltro: parametro.idConsultaFiltro }
                                });
                                const options = (comboData?.consultaCombo?.valorEsperado || []).map(adaptComboOption);
                                return adaptParametro(parametro, options);
                            } catch (error) {
                                console.error(`Error al cargar combo para ${parametro.idConsultaFiltro}:`, error);
                                return adaptParametro(parametro, []);
                            }
                        }
                        return adaptParametro(parametro, []);
                    })
                );

                setParametros(processedParametros);
                setParametrosError(null);
            })
            .catch((error) => {
                setParametrosError(error.message);
                setParametros([]);
            })
            .finally(() => {
                setParametrosLoading(false);
            });
    }, [idConsulta]);

    return {
        parametros,
        parametrosLoading,
        parametrosError
    };
};
